module.exports = __webpack_public_path__ + "img/img1.f9d2412a.png";